module.exports = __webpack_public_path__ + "static/media/AustClassManager.221453d3.png";